import { render, staticRenderFns } from "./CartModel.vue?vue&type=template&id=22f0a53d&scoped=true&"
import script from "./CartModel.vue?vue&type=script&lang=js&"
export * from "./CartModel.vue?vue&type=script&lang=js&"
import style0 from "./CartModel.vue?vue&type=style&index=0&id=22f0a53d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f0a53d",
  null
  
)

export default component.exports